jQuery(document).ready(function() {
    jQuery(".inventory-main").parent().addClass("inventory-page");
});
